<div class="bg-gray-100 p-4 mt-4 mb-4">
    <div class="flex flex-col">
      <h1 class="font-extrabold text-2xl p-6">Recommended</h1>
      <div class="flex flex-row overflow-scroll bg-scroll no-scrollbar">
        <ul *ngFor="let item of artist">
          <app-artist-card [artist]="item"></app-artist-card>
        </ul>
      </div>
    </div>
  </div>

  <p>{{message}}</p>
